import * as React from 'react';

function SvgReconciliation(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.571 1C14.361 1 15 1.64 15 2.429V13.57c0 .79-.64 1.429-1.429 1.429H2.43C1.639 15 1 14.36 1 13.571V2.43C1 1.639 1.64 1 2.429 1H13.57zm-5.12 2h-.936v1.232a2.286 2.286 0 00-.916.27 2.24 2.24 0 00-.647.54 2.177 2.177 0 00-.387.727 2.817 2.817 0 00-.127.846c0 .278.037.524.112.738.074.214.19.405.346.575.156.17.356.319.6.448.184.097.396.188.636.273l.25.083.58.184c.442.142.663.363.663.661a.627.627 0 01-.28.53 1.087 1.087 0 01-.657.204c-.544 0-1.101-.229-1.672-.685l-.191-.16L5 11.002c.129.122.294.24.494.351.2.112.416.21.646.295.231.085.465.153.703.204.158.034.31.057.457.068l.215.008v1.212h.937V11.88a5.578 5.578 0 001.003-.408c.274-.15.497-.322.666-.519.17-.197.292-.42.367-.672.075-.251.112-.54.112-.865 0-.537-.15-.973-.448-1.309-.261-.294-.666-.548-1.213-.761l-.243-.089-.6-.204a1.419 1.419 0 01-.51-.295c-.129-.122-.193-.251-.193-.387 0-.15.081-.283.244-.402.163-.119.373-.178.631-.178.369 0 .742.127 1.12.382l.163.117.754-1.466c-.44-.28-.968-.465-1.584-.557l-.27-.034V3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgReconciliation;
